<template>
  <div id="app">
    <NavbarComponent></NavbarComponent>
    <SidebarComponent></SidebarComponent>
    <router-view/>
  </div>
</template>

<script>
import SidebarComponent from '@/components/SidebarComponent.vue'
import NavbarComponent from '@/components/NavbarComponent.vue';

export default {
  components: {SidebarComponent, NavbarComponent},
};
</script>

<style>
:root {
    --title: #555;
    --body: #eee;
    --border: #efefef;
    --brand: #42b983;
    --text: #404040;
    --background: #dce1e3;
}
#app {
    /*font-family: Avenir, Helvetica, Arial, sans-serif;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    color: var(--text);
}
body {
    background-color: var(--body) !important;
    height: 100vh;
}
h1 {
    text-align: start;
    text-transform: uppercase;
    font-weight: 800;
    color: var(--title);
    font-size: 40px!important;
}
.form-control {
    background-color: var(--background) !important;
    border-color: var(--border) !important;
    color: var(--text) !important;
}
.page-link {
    background-color: var(--background) !important;
    font-size: 16px !important;
    border-color: var(--border) !important;
}
.page-item.active .page-link {
    color: var(--text) !important;
}
td {
    padding: 2px !important;
}
th {
    padding-top: 10px!important;
    padding-bottom: 10px!important;
}
.container-lg, .container {
    max-width: 2440px!important;
}
</style>